module.exports = __webpack_public_path__ + "static/img/versions.8f9852e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/versions.png
// module id = 4kWN
// module chunks = 0